function TabbedLayoutBlog() {
    this.extends = [TabbedLayout, _ResponsiveLayout];
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this.init = function() {
        this._super();
    };

    this.initAllReady = function() {
        this._super();
        this.registerResponsiveFunction($.proxy(this.resize, this, "compact"), 0, window.mogo.registry.mogoUI.config.mediaQueries.small);
        this.registerResponsiveFunction($.proxy(this.resize, this, "full"), window.mogo.registry.mogoUI.config.mediaQueries.small + 1, null);
    };

    this.resize = function(type) {
        if (type == "compact") {
            this.setSelectedTab(0);
        }
    };
}